import { ChakraProvider } from '@chakra-ui/react';
import { RoutesPages } from 'pages/routes';
import { BrowserRouter as Router } from 'react-router-dom';

import { theme } from 'theme';

const App = (): JSX.Element => {
    return (
        <ChakraProvider theme={theme}>
            <Router>
                <RoutesPages />
            </Router>
        </ChakraProvider>
    )
}

export default App;